import React, { useState } from "react";
import "../styles/contact.css";

const Contact = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText("nathan.illust@gmail.com");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } else {
      alert("Copy not supported on this device.");
    }
  };

  const [showPhone, setShowPhone] = useState(false);
  const [copiedPhone, setCopiedPhone] = useState(false);

  const handleCopyPhone = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText("+639216793479");
      setCopiedPhone(true);
      setTimeout(() => setCopiedPhone(false), 2000);
    } else {
      alert("Copy not supported on this device.");
    }
  };

  return (
    <div className="contact-box">
      <div className="contact-scroll-wrapper">
        <h2>Let's Connect!</h2>
        <p>
          Whether it’s a quest, a question, or just a hello —<br />
          you can link with me below!
          <br />
          <br />
          <h3>
            <em>Texts and e-mails preferred! Please no cold calls.. 😅</em>
          </h3>
        </p>

        <div className="contact-info">
          <div className="email-section">
            <label>Email:</label>
            <span className="email-text">nathan.illust@gmail.com</span>
          </div>
          <div className="email-actions">
            <button className="link-button" onClick={handleCopyEmail}>
              Copy Email
            </button>
            <a
              className="link-button"
              href="mailto:nathan.illust@email.com"
              target="_blank"
              rel="noreferrer"
            >
              Send Email
            </a>
          </div>
          <div className="phone-section">
            <label>Phone:</label>
            {showPhone ? (
              <div className="phone-reveal">
                <span className="phone-text">(+63) 921-679-3479</span>
                <button className="link-button" onClick={handleCopyPhone}>
                  Copy
                </button>
              </div>
            ) : (
              <button
                className="link-button"
                onClick={() => setShowPhone(true)}
              >
                Reveal Number
              </button>
            )}
          </div>
        </div>
        {copied && <div className="toast">📋 Email copied!</div>}
        {copiedPhone && <div className="toast">📋 Phone number copied!</div>}

        <div className="social-links">
          <a
            href="https://linkedin.com/in/nathanillust"
            target="_blank"
            rel="noreferrer"
            className="link-button"
          >
            🧙‍♂️ LinkedIn Profile
          </a>
          <br/>
          <a
            href="https://github.com/nathandesudesudesu"
            target="_blank"
            rel="noreferrer"
            className="link-button"
          >
            💻 Visit My GitHub
          </a>
          <br/>
          <a
            href="https://www.onlinejobs.ph/jobseekers/info/4200327"
            target="_blank"
            rel="noreferrer"
            className="link-button"
          >
            🌐 OnlineJobs.ph Profile
          </a>
          <br/>
          <a
            href="https://bit.ly/4g4J6f1"
            target="_blank"
            rel="noreferrer"
            className="link-button"
          >
            🎨 Miscellaneous Portfolio
          </a>
        </div>
      </div>
      <div id="linkPrompt" className="dialog-prompt">
        ▼
      </div>
    </div>
  );
};

export default Contact;
